import { render, staticRenderFns } from "./KeyboardFreewrite.vue?vue&type=template&id=6fcc8280"
import script from "./KeyboardFreewrite.vue?vue&type=script&lang=ts"
export * from "./KeyboardFreewrite.vue?vue&type=script&lang=ts"
import style0 from "./KeyboardFreewrite.vue?vue&type=style&index=0&id=6fcc8280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports